export default __webpack_public_path__ + "static/media/bg1.32dd226a.jpg";